module.exports = __webpack_public_path__ + "images/website-3_websites-desktop-mobile-april2019-31793c25016874de7de05d79fca24d3a.jpg";